var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6667H4C3.6 14.6667 3.33333 14.3333 3.33333 14V6C3.33333 5.6 3.6 5.33333 4 5.33333H7.33333C7.73333 5.33333 8 5.06667 8 4.66667C8 4.26667 7.73333 4 7.33333 4H3.33333C2.6 4 2 4.6 2 5.33333V14.6667C2 15.4 2.6 16 3.33333 16H12.6667C13.4 16 14 15.4 14 14.6667V10.6667C14 10.2667 13.6667 10 13.3333 10C13 10 12.6667 10.2667 12.6667 10.6667V14C12.6667 14.3333 12.3333 14.6667 12 14.6667ZM9.33333 4.66667C9.33333 5.06667 9.6 5.33333 10 5.33333H11.7333L5.66667 11.4C5.4 11.6667 5.4 12.0667 5.66667 12.3333C5.93333 12.6 6.33333 12.6 6.6 12.3333L12.6667 6.26667V8C12.6667 8.4 13 8.66667 13.3333 8.66667C13.6667 8.66667 14 8.4 14 8V4.66667C14 4.33333 13.6667 4 13.3333 4H10C9.6 4 9.33333 4.33333 9.33333 4.66667Z",
    fill: "#0C55B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindow);
export default __webpack_public_path__ + "static/media/NewWindow.3f001256d97bc12469db796b318b6a78.svg";
export { ForwardRef as ReactComponent };